import { ReactElement } from 'react';
import { Button } from './UI-CHAKRA/Button';
import { Text } from './UI-CHAKRA/Text';

interface ActionIconButtonProps {
  Icon: ReactElement;
  onClick(event: React.MouseEvent<HTMLButtonElement>): void;
  iconColor: string;
  iconHoverColor: string;
  role?: string;
  disabled?: boolean;
  dataCy?: string;
  dataTestId?: string;
  text?: string;
  border?: string;
  radius?: string;
  width?: string;
}

export function ActionIconButton(props: ActionIconButtonProps) {
  return (
    <Button
      w={props.width ? props.width : props.text ? 'auto' : '32px'}
      h={'32px'}
      size={'xs'}
      variant={'ghost'}
      aria-label={props.role}
      onClick={props.onClick}
      ml={'4px'}
      data-testid={props.dataTestId}
      fill={props.iconColor}
      _hover={{
        fill: props.iconHoverColor,
        boxShadow: '0px 0px 20px -3px rgba(0,0,0,0.15)',
      }}
      role={props.role}
      isDisabled={props.disabled}
      data-cy={props.dataCy}
      boxShadow={'3px 3px 10px 0px rgba(61, 14, 107, 0.10)'}
      borderRadius={props.radius ? props.radius : '10px'}
      border={props.border ? props.border : 'none'}
    >
      {props.Icon}

      {props.text && (
        <Text ml={'7px'} fontSize={'12px'} fontWeight={500} color={'typography.dark'}>
          {props.text}
        </Text>
      )}
    </Button>
  );
}
